// SCREENING JOBS (ACTIVE PROJECTS) ******************************************************
// pathname: /v1/screening/jobs
// ************************************************************************************************
import { useSwrApi } from '@hooks/useSwrApi/useSwrApi';
import type { ApiOkResponse } from '@type/api/apiUtilityFn';

interface UseSwrScreeningJobsProps {
  shouldFetch?: boolean;
  limit?: number;
  offset?: number;
  page?: number;
}

/**
 * @description SWR: fetch screening jobs (active projects) list with full details and pagination metadata.
 * @param props - { UseSwrScreeningJobsProps } - Configuration object with optional shouldFetch, limit, offset.
 */
export const useSwrScreeningJobs = (props?: UseSwrScreeningJobsProps) => {
  const {
    shouldFetch = true, limit, offset, page,
  } = props ?? {};

  const urlParams = [
    limit !== undefined ? `limit=${limit}` : '',
    offset !== undefined ? `offset=${offset}` : '',
    page !== undefined ? `page=${page}` : '',
  ].filter(Boolean).join('&');

  const {
    data, error, isLoading, isValidating, mutate,
  } = useSwrApi<ApiOkResponse<'/v1/screening/screenings/history', 'get'>>({
    url: '/v1/screening/screenings/history',
    urlParams: urlParams ? `?${urlParams}` : undefined,
    shouldFetch,
    apiOptions: {
      revalidateOnFocus: false,
      dedupingInterval: 60 * 1000, // 1 minute
    },
  });

  return {
    data,
    error,
    mutate,
    isLoading,
    isValidating,
  };
};
